import { render, staticRenderFns } from "./planHistory.vue?vue&type=template&id=19e61928&scoped=true&"
import script from "./planHistory.vue?vue&type=script&lang=js&"
export * from "./planHistory.vue?vue&type=script&lang=js&"
import style0 from "./planHistory.vue?vue&type=style&index=0&id=19e61928&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e61928",
  null
  
)

export default component.exports